
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/careers/open-positions/jobs/[...slugId]",
      function () {
        return require("private-next-pages/careers/open-positions/jobs/[...slugId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/careers/open-positions/jobs/[...slugId]"])
      });
    }
  